import { useOutletContext } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import MessageAttachments from 'modules/finance/components/MessageAttachments'
import MessageAttachmentsSkeleton from 'modules/finance/components/MessageAttachments/MessageAttachmentsSkeleton'
import MessageContent from 'modules/finance/components/MessageContent'
import MessageContentSkeleton from 'modules/finance/components/MessageContent/MessageContentSkeleton'
import MessageHeader from 'modules/finance/components/MessageHeader'
import MessageHeaderSkeleton from 'modules/finance/components/MessageHeader/MessageHeaderSkeleton'
import { useMessage } from 'modules/finance/hooks/useMessage'

interface OutletContext {
  messageId: number
}

const MessageContentPage = () => {
  const { messageId } = useOutletContext<OutletContext>()
  const id = messageId.toString()
  const { message, loading, markMessageAsRead, error } = useMessage(id)
  const { isRead } = message || {}

  if (error) {
    return null
  }
  if (!loading && !isRead) {
    markMessageAsRead({
      variables: {
        id,
      },
    })
  }

  return (
    <Box width="full" gapDivider>
      {loading ? <MessageHeaderSkeleton /> : <MessageHeader message={message} />}
      <Box padding="s24" gap="s24" style={{ flex: '1 1 auto', overflowY: 'auto' }}>
        {loading ? <MessageContentSkeleton /> : <MessageContent message={message} />}
        {loading ? <MessageAttachmentsSkeleton /> : <MessageAttachments message={message} />}
      </Box>
    </Box>
  )
}

export default MessageContentPage
